import React from "react";
import Card from "./Card";

const CardContainer = ({
  items,
  containerClasses = "",
  cardClasses = "",
  dropdownList = [],
  dropdownIndexes = [],
  textClasses = "",
}) => {
  if (items.length === 0) return "";
  let nextDropDownListIndex = 0;
  return (
    items.length !== 0 && (
      <div
        className={
          "relative m-auto flex flex-row flex-wrap lg:flex-col " +
          containerClasses
        }
      >
        {items.map((item, index) => (
          <Card
            title={item}
            key={index}
            classNames={cardClasses}
            subItems={
              dropdownIndexes.indexOf(index) !== -1
                ? dropdownList[nextDropDownListIndex++]
                : []
            }
            titleClassNames={textClasses}
            contentClassNames={textClasses}
          />
        ))}
      </div>
    )
  );
};

export default CardContainer;
